import type {
  SearchTransaction,
  SearchTransactionsCollection,
} from '@escrow/datastore/collections';
// eslint-disable-next-line local-rules/validate-freelancer-imports
import { addSearchTransformer } from '@freelancer/datastore/collections-testing/document-creators';
import type { Ordering, SearchQueryParams } from '@freelancer/datastore/core';
import { compareMultipleFields } from '@freelancer/datastore/core';
import { isDefined } from '@freelancer/utils';

export function addSearchTransformers(): void {
  addSearchTransformer<SearchTransactionsCollection>(
    'searchTransactions',
    searchTransactionsFilter,
  );
}

function searchTransactionsFilter(
  documents: readonly SearchTransaction[],
  { search }: SearchQueryParams,
  order?: Ordering<SearchTransactionsCollection>,
): readonly SearchTransaction[] {
  const filteredDocuments = documents.filter(transaction => {
    let result = true;

    if (isDefined(search)) {
      if (typeof search !== 'string') {
        throw new Error(
          "'search' field in search query params must be a string.",
        );
      }

      result =
        result &&
        transaction.description.toLowerCase().includes(search.toLowerCase());
    }

    return result;
  });

  return order
    ? filteredDocuments.sort((document1, document2) =>
        compareMultipleFields<SearchTransactionsCollection['DocumentType']>(
          Array.isArray(order) ? order : [order],
        )(document1, document2),
      )
    : filteredDocuments;
}
